import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import "./CtaBand.css";

export default function CtaBand({
  title = "Ready to take the next step?",
  subtitle = "Book a free consultation or review your portfolio with our experts.",
  primary = { label: "Book Free Consultation", to: "/contact" },
  secondary = { label: "Review My Portfolio", to: "/portfolio-review" },
}) {
  return (
    <section className="pm-cta-band">
      <div className="pm-cta-band__glow" />
      <div className="pm-container pm-cta-band__inner">
        <div>
          <h2>{title}</h2>
          <p>{subtitle}</p>
        </div>
        <div className="pm-cta-band__actions">
          <Link to={primary.to} className="pm-btn pm-btn-primary">
            {primary.label}
            <ArrowUpRight size={16} />
          </Link>
          {secondary && (
            <Link to={secondary.to} className="pm-btn pm-btn-outline">
              {secondary.label}
            </Link>
          )}
        </div>
      </div>
    </section>
  );
}
